<template>
  <div class="cube-container" v-if="MainPathIn">
    <div class="space3d" oncontextmenu="return false;" :style="HeightAndWidthStyles">
      <div class="_3dbox" :style="{transform : Transformation}">
        <div
          class="_3dface _3dface--front rain-background"
          :style="{...HeightAndWidthStyles , transform : 'translate3d(0, 0, ' + HalfHeightAndWidthStyles.width + ')'}"
        >
          <i class="fas fa-home cube-face-image"></i>
          <p class="cube-face-text">Home</p>
        </div>
        <div
          class="_3dface _3dface--top rain-background"
          :style="{...HeightAndWidthStyles , transform : 'rotateX(90deg) translate3d(0, 0,' + HalfHeightAndWidthStyles.width + ')'}"
        >
          <i class="far fa-address-card cube-face-image"></i>
          <p class="cube-face-text about-cube-text">About</p>
        </div>
        <div
          class="_3dface _3dface--bottom rain-background"
          :style="{...HeightAndWidthStyles , transform : 'rotateX(-90deg) translate3d(0, 0,' + HalfHeightAndWidthStyles.width + ')'}"
        >
          <i class="fas fa-wrench cube-face-image"></i>

          <p class="cube-face-text tools-cube-text">Tools</p>
        </div>
        <div
          class="_3dface _3dface--left rain-background"
          :style="{...HeightAndWidthStyles , 
          left : '50%' , 
          marginLeft: '-' + HalfHeightAndWidthStyles.width,
          transform : 'rotateY(-90deg) translate3d(0, 0,' + HalfHeightAndWidthStyles.width + ')'}"
        >
          <i class="fas fa-trophy cube-face-image"></i>

          <p class="cube-face-text works-cube-text">Achievements</p>
        </div>
        <div
          class="_3dface _3dface--right rain-background"
          :style="{...HeightAndWidthStyles , 
          left : '50%' , 
          'margin-left': '-' + HalfHeightAndWidthStyles.width , 
          transform : 'rotateY(90deg) translate3d(0, 0,' + HalfHeightAndWidthStyles.width + ')'}"
        >
          <i class="fas fa-envelope-square cube-face-image"></i>

          <p class="cube-face-text contact-cube-text">Contact</p>
        </div>
        <div
          class="_3dface _3dface--back rain-background"
          :style="{...HeightAndWidthStyles , transform : 'rotateY(180deg) translate3d(0, 0, ' + HalfHeightAndWidthStyles.width + ')'}"
        >
          <i class="fas fa-home cube-face-image"></i>

          <p class="cube-face-text">Home</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonFunctions from "../mixins/CommonFunctions";

export default {
  mixins: [CommonFunctions],
  props: {
    Height: Number,
    Width: Number,
  },
  data: function () {
    return {
      CurrentPageFace: "Home",
      movingInProgress: false,
      last_position: null,
      Transformation: null,
    };
  },
  methods: {
    MoveCubeTo: function (to) {
      const routes = require("../routing/routes").default;
      var wantedFace = routes.find(
        (item) => item.path.replace("/", "") === to.toLowerCase()
      );

      if (!wantedFace) {
        return;
      }

      var transormationDegrees = wantedFace.CubeTransformation;

      this.Transformation =
        "rotateX(" +
        transormationDegrees.xDegree +
        "deg) rotateY(" +
        transormationDegrees.yDegree +
        "deg)";

      setTimeout(this.ResetMovement, 500);
      this.CurrentPageFace = to;
    },

    ResetMovement: function () {
      this.movingInProgress = false;
    },
  },

  computed: {
    HeightAndWidthStyles: function () {
      return {
        height: this.Height + "px",
        width: this.Width + "px",
        lineHeight: this.Width + "px",
      };
    },
    HalfHeightAndWidthStyles: function () {
      return {
        height: this.Height / 2 + "px",
        width: this.Width / 2 + "px",
      };
    },
    MainPathIn: function () {
      return this.IsCurrentIsMainPath();
    },
  },
};
</script>

<style>
.cube-container {
  text-align: center;
  margin-top: 50px;
  position: fixed;
  z-index: 9999999;
  bottom: 85px;
  left: 50px;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=50)";
  filter: alpha(opacity=50);
  -moz-opacity: 0.5;
  -khtml-opacity: 0.5;
  /* opacity: 0.8; */
}

.space3d {
  perspective: 1000px;
  text-align: center;
  display: inline-block;
  /*browser support*/
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */

.space3d:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}

._3dbox {
  display: inline-block;
  transition: all 1.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  text-align: center;
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transform: rotateX(0deg) rotateY(15deg);
  /*browser support*/
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
}

._3dface {
  /*browser support*/
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;
}

._3dface {
  overflow: hidden;
  position: absolute;
  border: 2px solid #1a232b;
  box-shadow: inset 0 0 60px rgba(0, 0, 0, 0.1), 0 0 25px rgba(0, 0, 0, 0.3);
  color: #333;
  color: rgb(220, 214, 214);
  background-color: #03101d;
  /* line-height: 25px; */
  background-size: cover !important;
  background-position: center !important;
}

#radio-left:checked ~ .space3d ._3dbox {
  transform: rotateY(90deg);
}

#radio-right:checked ~ .space3d ._3dbox {
  transform: rotateY(-90deg);
}

#radio-bottom:checked ~ .space3d ._3dbox {
  transform: rotateX(90deg);
}

#radio-top:checked ~ .space3d ._3dbox {
  transform: rotateX(-90deg);
}

#radio-back:checked ~ .space3d ._3dbox {
  transform: rotateY(180deg);
}

._3dface {
  padding: 8px;
}

._3dface--front,
._3dface--left,
._3dface--right,
._3dface--top,
._3dface--bottom,
._3dface--back,
.rain-background {
  background: url("../assets/backgrounds_overlay/rain.jpg");
}

.cube-face-image {
  position: absolute;
  top: 10px;
  right: 17px;
  margin-bottom: 24px;
  height: 63px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  -ms-user-select: none;
  font-size: 28px;
  user-select: none;
  color: #aacbec;
}

.cube-face-text {
  position: absolute;
  bottom: -37px;
  left: 16px;
  color: #aacbec;
  font-weight: bold;
  font-size: 11px;
}

.cube-face-image.works-cube-face {
  right: 29px !important;
}

.works-cube-text {
  left: 1px;
  font-size: 9px;
}

.contact-cube-text {
  right: 23px;
}

.tools-cube-text {
  right: 31px;
}

.about-cube-text {
  right: 26px;
}
</style>